<template>
  <div class="max-w-2xl mx-auto">
    <h2 class="text-lg mb-4 font-bold">{{ __("SMS") }}</h2>

    <form class="mx-auto" @submit.prevent="submit()">

      <div class="mb-6">
        <textarea-input rows="4" v-model="form.approvalRequest" :label="__('Request parts approval')" :data-error="validationError('value.approvalRequest')"></textarea-input>
      </div>

      <div class="mb-6">
        <textarea-input rows="4" v-model="form.jobCompleteRequest" :label="__('Job finished')" :data-error="validationError('value.jobCompleteRequest')"></textarea-input>
      </div>

      <div class="mb-6">
        <textarea-input rows="4" v-model="form.feedbackRequest" :label="__('Job completed text')" :data-error="validationError('value.feedbackRequest')"></textarea-input>
      </div>

      <div class="mt-6 flex justify-center">
        <loading-button type="submit" :loading="submitting" class="justify-center text-xl px-4 min-w-40 py-2 rounded text-white bg-coral-400 hover:bg-coral-300">
          {{ __("Save") }}
        </loading-button>
      </div>
    </form>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import SettingsLayout from '@/Shared/SettingsLayout';
  import TextInput from '@/Shared/TextInput';
  import TextareaInput from '@/Shared/TextareaInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import Icon from '@/Shared/Icon';

  export default {
    layout: (h, page) => {
      return h(Layout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
      return {
        title: this.__("SMS")
      }
    },
    props: {
      sms: Object
    },
    data() {
      return {
        submitting: false,
        form: {}
      }
    },
    components: {
      Layout,
      TextInput,
      LoadingButton,
      TextareaInput,
      Icon
    },
    mounted() {
      this.form = this.sms;
    },
    methods: {
      submit() {
        this.submitting = true;
        this.$inertia.put(this.route('settings.update', {key: 'sms'}), {
          value: this.form
        }, {preserveState: false})
      }
    }
  }
</script>
